import loadable from '@loadable/component';

import { LoadingPageLoadable } from 'modules/main/pages/Loading';

export const SignupPageContainerLoadable = loadable(
  () =>
    import(
      /* webpackChunkName: "SignupPageContainer" */
      './SignupPageContainer.dynamic'
    ),
  { fallback: <LoadingPageLoadable /> },
);
